import { useState, useEffect } from 'react';

export function useAuth() {
  const [auth, setAuth] = useState(() => {
    const storedAuth = JSON.parse(localStorage.getItem('auth'));
    return storedAuth || {
      isLoggedIn: false,
      is2FA: false,
      token: null,
      qrCodeUrl: null, 
    };
  });

  const login = (userData) => {
    localStorage.setItem('auth', JSON.stringify(userData));
    setAuth(userData);
  };

  const logout = () => {
    localStorage.removeItem('auth');
    localStorage.removeItem('currentSession');
    setAuth({ isLoggedIn: false, is2FA: false, token: null, qrCodeUrl: null,});
  };

  return { auth, login, logout };
}